import React from "react";
import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import Publishers from "@/components/sections/Publishers";
import Advertisers from "@/components/sections/Advertisers";
import Manga from "@/components/sections/Manga";
import ImpactSection from "@/components/sections/ImpactSection";
import GlobalPlatform from "@/components/sections/GlobalPlatform";
import About from "@/components/sections/About";
import Testimonials from "@/components/sections/Testimonials";
import Faq from "@/components/sections/Faq";
import Cta from "@/components/sections/Cta";

export default function Home() {
  return (
    <main className="relative">
      <Hero />
      <ImpactSection />
      <GlobalPlatform />
      <Services />
      <Publishers />
      <Advertisers />
      <Manga />
      <Testimonials />
      <About />
      <Faq />
      <Cta />
    </main>
  );
}
